module.exports = __webpack_public_path__ + "static/media/bloc-tete.41d08af0.jpg";